module.exports = __webpack_public_path__ + "img/20.751e8ee6.jpg";